// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1s3Br","buttons":"Footer_buttons__1rd76"};